"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNearbyCommuteEstimatorState = void 0;
var NearbyCommuteEstimatorState_1 = require("./NearbyCommuteEstimatorState");
var NearbyCommuteMethods_1 = require("./NearbyCommuteMethods");
exports.defaultNearbyCommuteEstimatorState = {
    isSuggesting: false,
    keyword: '',
    durationValue: 0,
    durationUnit: NearbyCommuteEstimatorState_1.NearbyCommuteDurationUnit.MIN,
    commuteMethod: NearbyCommuteMethods_1.NearbyCommuteMethods.DRIVE,
    selectedPlace: null,
    suggestions: null,
    isSelecting: false,
};
